import InnerWrap from './InnerWrap'
export default InnerWrap